import { Capacitor } from '@capacitor/core';
import { PushNotifications, Token } from '@capacitor/push-notifications';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

export class PushService {
  private static registeredFor: string | null = null;

  // Call after a user signs in. No-op on web — FCM web push needs a
  // service worker + VAPID key, which isn't configured yet.
  static async registerForUser(userId: string): Promise<void> {
    if (!Capacitor.isNativePlatform() || this.registeredFor === userId) return;
    this.registeredFor = userId;

    PushNotifications.addListener('registration', (token: Token) => {
      this.saveToken(userId, token.value);
    });

    PushNotifications.addListener('registrationError', (err) => {
      console.error('Push registration failed:', err.error);
    });

    const perm = await PushNotifications.requestPermissions();
    if (perm.receive !== 'granted') return;

    await PushNotifications.register();
  }

  static async unregister(): Promise<void> {
    if (!Capacitor.isNativePlatform()) return;
    this.registeredFor = null;
    await PushNotifications.removeAllListeners();
  }

  private static async saveToken(userId: string, token: string): Promise<void> {
    try {
      await setDoc(doc(db, 'users', userId), { fcmToken: token }, { merge: true });
    } catch (e) {
      console.error('Failed to save FCM token:', e);
    }
  }
}
